import { ButtonBase, Icon } from '@material-ui/core';
import { PageHeader } from '../../../../components';
import CounterTabs from './CounterTabs';
import { AuctionTabs } from '../../../../components/AuctionTabs';
import { useScreen } from 'usehooks-ts';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters, setPage } from '../../../../services/byMids/myBidsSlice';
import apiSlice from '../../../../services/api';

const Header = () => {
  const { width } = useScreen();
  const isMobile = width < 567;

  const dispatch = useDispatch();

  const { filters } = useSelector(state => state.myBids);

  const selectTab = tab =>
    dispatch(
      setFilters({
        auctionType: tab,
        auctionStatus: tab === 'all' ? 'combined' : 'active'
      })
    );

  const handleRefresh = () => {
    dispatch(setPage(1));
    dispatch(apiSlice.util.invalidateTags(['MyBids', 'MyBidsCounters']));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <PageHeader>
      <AuctionTabs
        paddings={isMobile ? 'md' : 'lg'}
        fontSize={isMobile ? 'md' : 'lg'}
        selectTab={selectTab}
        selectedTab={filters.auctionType}
        hideNonActive
        includeAllTab
      />
      <span className="flex-grow" />
      <ButtonBase onClick={handleRefresh}>
        <Icon>refresh</Icon>
      </ButtonBase>
    </PageHeader>
  );
};

export default Header;
